import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { styles } from '../../../utils/styles';
export const CareProviderPDF = ({
  assignedRoles
}) => /*#__PURE__*/React.createElement(View, {
  style: [styles.width20, styles.paddingRightPointOneCm]
}, assignedRoles && assignedRoles.map(assignment => {
  const {
    firstname,
    lastname,
    credentials
  } = assignment;
  return /*#__PURE__*/React.createElement(Text, {
    key: `${firstname}${lastname}`,
    style: styles.CPFTableDetailsText
  }, `${firstname} ${lastname} `, credentials && `${credentials}`);
}));